import { createConfig, http } from 'wagmi';
import { mainnet, base } from 'wagmi/chains';
import { coinbaseWallet, injected, walletConnect } from 'wagmi/connectors';

const ethereumRpcUrl =
  process.env.NEXT_PUBLIC_ETHEREUM_RPC_URL ||
  process.env.NEXT_PUBLIC_MAINNET_RPC_URL ||
  'https://cloudflare-eth.com';

const baseRpcUrl =
  process.env.NEXT_PUBLIC_BASE_RPC_URL ||
  'https://mainnet.base.org';

export const injectedConnector = injected({
  shimDisconnect: true,
});

// MetaMask-targeted injected connector (no @metamask/sdk dependency).
// This helps avoid environments where multiple injected wallets are present
// (e.g., Brave Wallet + MetaMask) and we want to specifically target MetaMask.
export const metaMaskInjectedConnector = injected({
  shimDisconnect: true,
  target: 'metaMask',
});

export const coinbaseConnector = coinbaseWallet({
  appName: 'Reqrium',
  appLogoUrl: undefined,
});

const walletConnectProjectId = process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID;

export const walletConnectConnector = walletConnectProjectId
  ? walletConnect({
      projectId: walletConnectProjectId,
      showQrModal: true,
      metadata: {
        name: 'Reqrium',
        description: 'Wallet intelligence, trust verification, and reputation scoring',
        url: process.env.NEXT_PUBLIC_APP_URL || 'https://www.reqrium.com',
        icons: ['https://www.reqrium.com/block411-logo.svg'],
      },
    })
  : null;

export const wagmiConfig = createConfig({
  chains: [mainnet, base],
  connectors: [metaMaskInjectedConnector, injectedConnector, coinbaseConnector, ...(walletConnectConnector ? [walletConnectConnector] : [])],
  transports: {
    [mainnet.id]: http(ethereumRpcUrl),
    [base.id]: http(baseRpcUrl),
  },
  ssr: true,
});
